<script>
	import { onMount } from 'svelte';
	import Button from './Button.svelte';
	import Dial from './Dial.svelte';
	import Footer from './Footer.svelte';
	import GameScreen from './GameScreen.svelte';
	import Jauge from './Jauge.svelte';
	import { getTrad,language,network_errors,screen } from './js/AppState';
	import DataLoading from './js/DataLoading';
	import { SCREENS } from './js/ids';
	import SGMSApi from './js/SGMSApi';
	import { getUrlParam } from './js/utils';
	import LanguageSelector from './LanguageSelector.svelte';
	import Loader from './Loader.svelte';
	import MailScreen from './MailScreen.svelte';
	import PartageScreen from './PartageScreen.svelte';
	import RgpdScreen from './RgpdScreen.svelte';
	import ScreenOrientation from './ScreenOrientation.svelte';
	import Title from './Title.svelte';
	import Topbar from './Topbar.svelte';
	import VideoScreen from './VideoScreen.svelte';
  export let lang;

  /// STATE
  let showOrientationAlert = false

  let TIMOUT = null


  onMount(() => {
    DataLoading.getAllFiles()
    .then(() => {
      SGMSApi.init(CONFIG.server_url, CONFIG.server_port)
      return SGMSApi.anonymousConnect(CONFIG.server_universe, CONFIG.server_app)
    })
    .then(() => {
      console.log("connected")
      SGMSApi.sendNavigationEvent(window.location.href, "ENTER")

      if(lang && DataLoading.languages.find(l => l.id === lang)) {
        language.set(lang)
      } else {
        language.set("en")
      }

      console.log("LOADING DONE")
      screen.set(getUrlParam("screen", getUrlParam("screen", SCREENS.INIT)))
    })

    TIMOUT = setTimeout(glitch, Math.random() * window.CONFIG.glitch_delay);

    window.addEventListener("resize", function() {
      checkOrientation($screen)
    });


    window.onbeforeunload = function () {
      SGMSApi.sendNavigationEvent(window.location.href, "LEAVE")
    };
  });

  ////////



  $: checkOrientation($screen)
  function checkOrientation(screen) {
    if(window.innerWidth > 800) {
      showOrientationAlert = false
      return
    }
    // les screens qui doivent avoir l'alerte si vertical :
    let horiz_screens = [ SCREENS.VIDEO, SCREENS.GAME, SCREENS.ORIENTATION ]

    let shouldBeVertical = horiz_screens.indexOf(screen) === -1

    let verticalError = (shouldBeVertical && window.innerHeight < window.innerWidth)
    let horizError = (!shouldBeVertical && window.innerHeight > window.innerWidth)
    showOrientationAlert = verticalError || horizError
  }

  let showGlitch = false
  function glitch() {
    showGlitch = true
    setTimeout(() => {
      showGlitch = false
      TIMOUT = setTimeout(glitch, Math.random() * window.CONFIG.glitch_delay);
    }, Math.random() * window.CONFIG.glitch_duration);
  }


  $: gamestyle =  $screen === SCREENS.GAME ? "opacity: 1;pointer-events: auto; z-index: 5;" : "opacity: 0; pointer-events: none; z-index: -1;"
</script>


<div id="app" class="app">
  {#if $screen === SCREENS.LOADING}
    <Loader />
  {:else}
    <div class="glitch" class:visible={showGlitch} />

    {#if $screen !== SCREENS.INIT}
      <GameScreen style={gamestyle} on:gameend={()=>{ screen.set(SCREENS.DIAL_END) }} />
    {/if}

    <Title />

    <Topbar showLanguages={$screen !== SCREENS.INIT} />

    <div class="app-content">

      {#if $screen === SCREENS.INIT}
        <LanguageSelector on:next={()=>{ screen.set(SCREENS.RGPD) }} />
      {/if}

      {#if  $screen === SCREENS.RGPD}
        <RgpdScreen on:close={()=>{ screen.set(SCREENS.DIAL_START) }} />
      {/if}

      {#if  $screen === SCREENS.DIAL_START}
        <Dial ids={["startdial_01", "startdial_02", "startdial_03", "startdial_04", "startdial_05", "startdial_06"]} >
          <Button name="ButtonDialStartImReady" on:click={()=>{ screen.set(SCREENS.VIDEO) }}>
            {$getTrad("Welcome")}
          </Button>
        </Dial>
      {/if}

      {#if  $screen === SCREENS.VIDEO}
        <VideoScreen on:videoend={()=>{ screen.set(SCREENS.GAME) }} />
      {/if}

      {#if  $screen === SCREENS.DIAL_END}
        <Dial ids={["enddial_01", "enddial_02"]} >
          <Button name="ButtonDialEndNext" on:click={()=>{ screen.set(SCREENS.JAUGE) }}>
            {$getTrad("next_btn")}
          </Button>
        </Dial>
      {/if}

      {#if  $screen === SCREENS.JAUGE}
        <Jauge on:next={()=>{ screen.set(SCREENS.MAIL) }} />
      {/if}

      {#if  $screen === SCREENS.MAIL}
        <MailScreen on:close={()=>{ screen.set(SCREENS.PARTAGE)}} />
      {/if}

      {#if  $screen === SCREENS.PARTAGE}
        <PartageScreen on:close={()=>{ screen.set(SCREENS.DIAL_END2)}} />
      {/if}

      {#if  $screen === SCREENS.DIAL_END2}
        <Dial ids={["enddial_03", "enddial_04"]} >
          <Button name="ButtonFindOut" href={$getTrad("Find_out_SG")}>{$getTrad("End_Game_01")}</Button>
          <Button name="ButtonJobVacancies" href={$getTrad("Jobs_SG")}>{$getTrad("End_Game_02")}</Button>
        </Dial>
      {/if}

      {#if  $screen === SCREENS.GAME}
        <div></div>
      {/if}



    </div>  <!-- /.content -->

    <div class="footer">
      <Footer />
    </div>
  {/if}


  {#if $network_errors.length > 0}
    <div class="network-errors">
      {#each $network_errors as err}
        <div>{err}</div>
      {/each}
    </div>
  {/if}
  {#if showOrientationAlert}
    <ScreenOrientation />
  {/if}


</div>  <!-- /#app -->


<style>





</style>
